import { strToFloat, trimTextContent } from 'services/utils';

export default (templateData) => ({
  amount: strToFloat(templateData?.amount?.toString()),
  paymentMethod: templateData?.paymentMethod,
  comment: trimTextContent(templateData?.comment)
});
